import { UserRole } from 'src/auth/types';
import { EducationLevelGroup } from 'src/constants';
import { LessonsDuration } from 'src/constants/centers';
import { LessonType } from '../enums/lesson.enum';

export const GradeRangeToLessonDuration = {
    [EducationLevelGroup.PRESCHOOL]: LessonsDuration.MINUTES30,
    [EducationLevelGroup.JUNIOR_SCHOOL]: LessonsDuration.MINUTES45,
    [EducationLevelGroup.HIGH_SCHOOL]: LessonsDuration.MINUTES60
};

type SubjectType = 'PSYCHOLOGY' | 'SPECIAL' | 'NORMAL' | 'FOREIGN';

export const roleSubjectTypesMap: Partial<Record<UserRole, SubjectType[]>> = {
    [UserRole.PSYCHOLOGIST]: ['PSYCHOLOGY'],
    [UserRole.SPEECH_THERAPIST]: ['SPECIAL'],
    [UserRole.INTELLECTUAL_DISABILITY_TEACHER]: ['SPECIAL'],
    [UserRole.VISION_TEACHER]: ['SPECIAL'],
    [UserRole.DEAF_TEACHER]: ['SPECIAL'],
    [UserRole.TEACHER_PPP]: ['SPECIAL'],
    [UserRole.SPECIAL_EDUCATION_TEACHER]: ['NORMAL', 'SPECIAL', 'PSYCHOLOGY'],
    [UserRole.JUNIORS_TEACHER]: ['NORMAL'],
    [UserRole.ASSISTANT_JUNIORS_TEACHER]: ['NORMAL'],
    [UserRole.PRESCHOOL_TEACHER]: ['NORMAL'],
    [UserRole.ASSISTANT_PRESCHOOL_TEACHER]: ['NORMAL'],
    [UserRole.FOREIGN_LANGUAGE_TEACHER]: ['FOREIGN'],
    [UserRole.TEACHER]: ['NORMAL']
};

export const EducationLevelToRolesMap = {
    [EducationLevelGroup.PRESCHOOL]: [
        UserRole.PRESCHOOL_TEACHER,
        UserRole.PSYCHOLOGIST,
        UserRole.SPEECH_THERAPIST,
        UserRole.INTELLECTUAL_DISABILITY_TEACHER,
        UserRole.VISION_TEACHER,
        UserRole.DEAF_TEACHER,
        UserRole.SPECIAL_EDUCATION_TEACHER,
        UserRole.TEACHER_PPP
    ],
    [EducationLevelGroup.JUNIOR_SCHOOL]: [
        UserRole.JUNIORS_TEACHER,
        UserRole.PSYCHOLOGIST,
        UserRole.SPEECH_THERAPIST,
        UserRole.INTELLECTUAL_DISABILITY_TEACHER,
        UserRole.VISION_TEACHER,
        UserRole.DEAF_TEACHER,
        UserRole.SPECIAL_EDUCATION_TEACHER,
        UserRole.TEACHER_PPP,
        UserRole.FOREIGN_LANGUAGE_TEACHER
    ],
    [EducationLevelGroup.HIGH_SCHOOL]: [
        UserRole.TEACHER,
        UserRole.PSYCHOLOGIST,
        UserRole.SPEECH_THERAPIST,
        UserRole.INTELLECTUAL_DISABILITY_TEACHER,
        UserRole.VISION_TEACHER,
        UserRole.DEAF_TEACHER,
        UserRole.SPECIAL_EDUCATION_TEACHER,
        UserRole.FOREIGN_LANGUAGE_TEACHER,
        UserRole.TEACHER_PPP
    ]
};

export const UserRoleToAPIPathMap: Record<UserRole, string | null> = {
    [UserRole.SYSTEM_ADMIN]: null,
    [UserRole.ADMIN]: null,
    [UserRole.SECRETARIAT]: null,
    [UserRole.PRESCHOOL_TEACHER]: 'teachers',
    [UserRole.ASSISTANT_PRESCHOOL_TEACHER]: 'teachers',
    [UserRole.JUNIORS_TEACHER]: 'teachers',
    [UserRole.ASSISTANT_JUNIORS_TEACHER]: 'teachers',
    [UserRole.TEACHER]: 'teachers',
    [UserRole.PSYCHOLOGIST]: 'psychologists',
    [UserRole.PARENT]: null,
    [UserRole.SPEECH_THERAPIST]: 'specials',
    [UserRole.INTELLECTUAL_DISABILITY_TEACHER]: 'specials',
    [UserRole.VISION_TEACHER]: 'specials',
    [UserRole.DEAF_TEACHER]: 'specials',
    [UserRole.METHODOLOGIST]: null,
    [UserRole.TEACHER_PPP]: 'specials',
    [UserRole.SPECIAL_EDUCATION_TEACHER]: 'teachers',
    [UserRole.FOREIGN_LANGUAGE_TEACHER]: 'teachers'
};

export const UserRoleToLessonTypeMap: Partial<Record<UserRole, LessonType | null>> = {
    [UserRole.PRESCHOOL_TEACHER]: LessonType.LESSON,
    [UserRole.ASSISTANT_PRESCHOOL_TEACHER]: LessonType.LESSON,
    [UserRole.JUNIORS_TEACHER]: LessonType.LESSON,
    [UserRole.ASSISTANT_JUNIORS_TEACHER]: LessonType.LESSON,
    [UserRole.TEACHER]: LessonType.LESSON,
    [UserRole.PSYCHOLOGIST]: LessonType.PSYCHOLOGIST_SESSION,
    [UserRole.SPEECH_THERAPIST]: LessonType.SPEECH_THERAPIST_SESSION,
    [UserRole.INTELLECTUAL_DISABILITY_TEACHER]: LessonType.OLIGOPHRENOPEDAGOGUE_SESSION,
    [UserRole.VISION_TEACHER]: LessonType.TIFLOPEDAGOG_SESSION,
    [UserRole.DEAF_TEACHER]: LessonType.SURDOPEDAGOGIST_SESSION,
    [UserRole.TEACHER_PPP]: LessonType.PSYCHOLOGIST_SESSION_WITH_PARENTS,
    [UserRole.SPECIAL_EDUCATION_TEACHER]: LessonType.LESSON,
    [UserRole.FOREIGN_LANGUAGE_TEACHER]: LessonType.LESSON
};
